module.exports = __webpack_public_path__ + "img/ic-poussieres.4aa08962.svg";